import { useDialog } from '@workramp/ui';
import isFeatureEnabled from '~/components/common/is-feature-enabled';
import AcademyUserAvatar from '~/components/academies/common/academy-user-avatar';
import { apiDelete } from '~/common';
import { I18n } from '~/common/explicit-exports';
import { MyTeamsReportModal } from '~/clc/features/learner-navigation/components/AcademyThemeNavigation/MyTeamReportsModal';

const LEARNER_PROFILE_URL = '/profile/';
const LEARNER_MY_TRAININGS_URL = '/profile/my_trainings/';
const LEARNER_MY_ORDERS_URL = '/profile/orders/';
const LEARNER_LOGOUT_URL = '/logout';

const TRANSLATED_PROFILE = I18n.t('js.academy.navigation.profile');
const TRANSLATED_MY_TRAININGS = I18n.t('common.academy.content.my_trainings');
const TRANSLATED_ORDER_HISTORY = I18n.t('js.academy.navigation.order_history');
const TRANSLATED_MY_TEAM_REPORTS = I18n.t('js.academy.navigation.my_team_reports');
const TRANSLATED_LOGOUT = I18n.t('js.academy.navigation.logout');

export const ProfileLink = ({ academy, externalUser, linkColor, subnavActiveLinkColor }) => {
  const { getUrlParameters, location } = window;
  const { avatar, displayName } = externalUser;

  const myTeamsReportModal = useDialog(MyTeamsReportModal);

  const openMyTeamReportsModal = (props) => {
    myTeamsReportModal.open({
      ...props,
      academy,
      onClose: () => myTeamsReportModal.remove(),
    });
  };

  const logoutCurrentUser = () => {
    if (getUrlParameters().prevent_default !== 'true') {
      apiDelete(
        'logout',
        null,
        (resp) => {
          location.href = resp;
        },
        () => location.reload(),
        '/',
      );
    }
  };

  const goToProfile = () => {
    if (getUrlParameters().prevent_default !== 'true') {
      location.href = LEARNER_PROFILE_URL;
    }
  };

  const goToMyTrainings = () => {
    if (getUrlParameters().prevent_default !== 'true') {
      location.href = LEARNER_MY_TRAININGS_URL;
    }
  };

  const goToOrderHistory = () => {
    if (getUrlParameters().prevent_default !== 'true') {
      location.href = LEARNER_MY_ORDERS_URL;
    }
  };

  const subMenu = [
    {
      linkText: TRANSLATED_PROFILE,
      clickHandler: goToProfile,
      href: LEARNER_PROFILE_URL,
    },
    {
      linkText: academy.themeOptions.contentLabelOverrides.my_trainings || TRANSLATED_MY_TRAININGS,
      clickHandler: goToMyTrainings,
      badgeCount: isFeatureEnabled('academies_assignments') ? externalUser.outstandingAssignmentsCount : undefined,
      href: LEARNER_MY_TRAININGS_URL,
    },
    ...(isFeatureEnabled('ecommerce') && academy.isEcommerceSetUp
      ? [
          {
            linkText: TRANSLATED_ORDER_HISTORY,
            clickHandler: goToOrderHistory,
            href: LEARNER_MY_ORDERS_URL,
          },
        ]
      : []),
    ...(isFeatureEnabled('fy26_q2_clc_team_leads') && externalUser?.isTeamLeadContact
      ? [
          {
            linkText: TRANSLATED_MY_TEAM_REPORTS,
            clickHandler: openMyTeamReportsModal,
            href: null,
          },
        ]
      : []),
    {
      linkText: TRANSLATED_LOGOUT,
      clickHandler: logoutCurrentUser,
      href: LEARNER_LOGOUT_URL,
    },
  ];

  return (
    <AcademyUserAvatar
      backgroundColor="transparent"
      className="academy-navigation-user-avatar"
      imageSrc={avatar || ''}
      name={displayName}
      subMenu={subMenu}
      subMenuWidth={135}
      width={40}
      textColor={linkColor}
      textHoverColor={linkColor}
      subnavActiveLinkColor={subnavActiveLinkColor}
    />
  );
};
